(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-review-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var LINK_SELECTOR = '.product-review-bar__reviews-link';
    var JUDGE_SELECTOR = '.judgeme-count';
    var COUNT_SELECTOR = '.AirReviews-Blocks--ReviewCount__Text';

    function formatLinkText(raw, suffix) {
      var text = String(raw || '').replace(/\s+/g, ' ').trim();
      if (!text) return '';
      if (/review/i.test(text)) return text;
      return suffix ? text + ' ' + suffix : text;
    }

    function formatJudgeMeCount(raw) {
      var text = String(raw || '').replace(/\s+/g, ' ').trim();
      if (!text) return '';
      var stripped = text.replace(/[()]/g, '').replace(/reviews?/gi, '').trim();
      if (!stripped) return '';
      var count = parseInt(stripped.replace(/,/g, ''), 10);
      var label = count === 1 ? 'Review' : 'Reviews';
      return '(' + stripped + ' ' + label + ')';
    }

    function applyFromWidget() {
      var countEl = document.querySelector(COUNT_SELECTOR);
      if (!countEl) return false;

      var raw = countEl.textContent;
      if (!raw || !raw.trim()) return false;

      var links = document.querySelectorAll(LINK_SELECTOR);
      var updated = false;

      for (var i = 0; i < links.length; i++) {
        var suffix = links[i].getAttribute('data-reviews-suffix') || '';
        var next = formatLinkText(raw, suffix);
        if (next) {
          links[i].textContent = next;
          updated = true;
        }
      }

      var bar = document.querySelector('.product-review-bar[data-product-id]');
      var productId = bar ? bar.getAttribute('data-product-id') : '';
      var judgeCounts = document.querySelectorAll(JUDGE_SELECTOR);

      for (var j = 0; j < judgeCounts.length; j++) {
        var wrap = judgeCounts[j].closest('[data-product-id]');
        if (productId && wrap && wrap.getAttribute('data-product-id') !== productId) continue;
        var judgeText = formatJudgeMeCount(raw);
        if (judgeText) {
          judgeCounts[j].textContent = judgeText;
          updated = true;
        }
      }

      return updated;
    }

    function start() {
      if (applyFromWidget()) return;
      if (!document.querySelector(LINK_SELECTOR)) return;
      if (!('MutationObserver' in window) || !document.body) return;

      var observer = new MutationObserver(function () {
        if (applyFromWidget()) observer.disconnect();
      });

      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
      setTimeout(function () {
        observer.disconnect();
      }, 12000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
